/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_Q2Inputs */

const et_faq_q2 = /** @type {(inputs: Faq_Q2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kas ScalingWebs viib ettevõtte Google Mapsi esikolmikusse?`)
};

const en_faq_q2 = /** @type {(inputs: Faq_Q2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Can ScalingWebs get my business into the top 3 on Google Maps?`)
};

/**
* | output |
* | --- |
* | "Can ScalingWebs get my business into the top 3 on Google Maps?" |
*
* @param {Faq_Q2Inputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const faq_q2 = /** @type {((inputs?: Faq_Q2Inputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_Q2Inputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_faq_q2(inputs)
	return en_faq_q2(inputs)
});